import { render } from "./CView.vue?vue&type=template&id=aa9deb64&scoped=true&ts=true"
import script from "./CView.ts?vue&type=script&lang=ts"
export * from "./CView.ts?vue&type=script&lang=ts"

import "./CView.scss?vue&type=style&index=0&id=aa9deb64&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa9deb64"]])

export default __exports__